// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__2lpEe","disabled":"FileBtn_disabled__18Wx0","warn":"FileBtn_warn__1_9V0","fade":"FileBtn_fade__7vpZu"};